var $ = jQuery.noConflict();

$(function(){



    
function sg9ExpandProductSpecifications() {
        
    if ( $('body').hasClass('template-product') ) { 

        //var documentWidth = $(document).width();        
        var documentWidth = $(window).outerWidth();        
        //var documentWidth = $(window).width();        

        // Set to true to keep specifications always expanded regardless of viewport width
        // Set to false to use the existing behavior (hide on mobile ≤550px, show on desktop >550px)
        var alwaysExpanded = true;
        
        // Remove any existing click handlers to prevent stacking
        $('.product-specifications-title').off('click');
        
        // Handle initial visibility based on width or alwaysExpanded flag
        if (alwaysExpanded || documentWidth > 550) {                
            $('#product-specifications').show();
            $('.product-specifications-title').attr('aria-expanded', true).addClass('expand');
        } else {
            $('#product-specifications').hide();
            $('.product-specifications-title').attr('aria-expanded', false).removeClass('expand');
        }

        // Always set up click handler so toggle works regardless of initial state
        $('.product-specifications-title').on('click',function(){
            if($(this).hasClass('expand')){
                $(this).removeClass('expand');
                $(this).next().slideUp();
                $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                $(this).attr('aria-expanded', false);
            } else {
                $(this).addClass('expand');
                $(this).next().slideDown();
                $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
                $(this).attr('aria-expanded', true);
            }
        });
    }

//console.log("documentWidth:" + documentWidth);

} // sg9ExpandProductSpecifications()

    sg9ExpandProductSpecifications();



if ( $('body').hasClass('template-product') ) { 

    setTimeout(function() {

        $('.pl-swatches__color').each(function() {
            $(this).closest('a.pl-swatches__link').addClass('swatch-color');
    
       /* $('.pl-swatches__tooltip').each(function() {
            let text = $(this).text();
    
            if (text.includes("Checkerboard")) {
                $(this).text(text.replace(/Checkerboard/g, "Checker-board"));
            }
    
            if (text.includes("Pomegranate")) {
                $(this).text(text.replace(/Pomegranate/g, "Pome-granate"));
            }
    
            if (/Rectangular\b/i.test(text)) {
                $(this).text(text.replace(/\bRectangular\b/gi, "Rectangu-lar"));
            }
    
            if (text.includes("/Gold")) {
                $(this).text(text.replace(/\/Gold/g, "/ Gold"));
            }
    
            if (text.includes("/")) {
                $(this).text(text.replace(/\//g, " / "));
            }
        });
        });
    
        $('.pl-swatches__tooltip').each(function() {
            let text = $(this).text();
    
            if (text.includes("Checkerboard")) {
                $(this).text(text.replace(/Checkerboard/g, "Checker-board"));
            }
    
            if (text.includes("Pomegranate")) {
                $(this).text(text.replace(/Pomegranate/g, "Pome-granate"));
            }
    
            if (/Rectangular\b/i.test(text)) {
                $(this).text(text.replace(/\bRectangular\b/gi, "Rectangu-lar"));
            }
    
            if (text.includes("/Gold")) {
                $(this).text(text.replace(/\/Gold/g, "/ Gold"));
            }
    
            if (text.includes("/")) {
                $(this).text(text.replace(/\//g, " / "));
            }
*/
                
        }); 
    
    }, 250);
    
   
  
}


function sg9ProductHugeDeal() {


    if ($('body').hasClass('template-product-huge-deal')) {

        var documentWidth = $(document).width();

        $('.product-description ul').hide();

        $('.product-description p:first-child strong').on('click',function(){

        if($(this).parent().hasClass('expand')){
            $(this).parent().removeClass('expand');
            $(this).parent().next().slideUp();
            $(this).parent().find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
            $(this).parent().attr('aria-expanded', false)

        } else {
            $(this).parent().addClass('expand');
            $(this).parent().next().slideDown();
            $(this).parent().find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            $(this).parent().attr('aria-expanded', true)
        }

    });

    }




} // sg9ProductHugeDeal()

sg9ProductHugeDeal();



	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */		
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {
		if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;

			sg9ExpandProductSpecifications();	
			
		}           
		
	} // resizeend()


    // Auto-expand "What's included" for Ultimate Set products (set up BEFORE hiding others)
    /*
    $('.custom-set-product.custom-ultimate-set').each(function(){
        var $productItem = $(this).closest('.product-item');
        var $content = $productItem.find('.whats-included-content');
        var $trigger = $productItem.find('.whats-included-heading');
        var $icon = $trigger.find('.whats-included-heading-icon');
        
        $content.show();
        $trigger.addClass('expand');
        $trigger.attr('aria-expanded', true);
        $icon.addClass('rotate');
    });*/

    // Hide all "What's included" EXCEPT Ultimate Set
    //$('.product-item:not(:has(.custom-ultimate-set)) .whats-included-content').hide();
    $('.product-item .whats-included-content').hide();

    // "What's included" collapsible toggle - same pattern as FAQ accordion
    $('.whats-included-heading').on('click',function(){
        var $trigger = $(this);
        var $icon = $trigger.find('.whats-included-heading-icon');
        
        if($trigger.hasClass('expand')){
            $trigger.removeClass('expand');
            $trigger.next().slideUp();
            $trigger.attr('aria-expanded', false);
            $icon.removeClass('rotate');
        } else {
            $trigger.addClass('expand');
            $trigger.next().slideDown();
            $trigger.attr('aria-expanded', true);
            $icon.addClass('rotate');
        }
    });

    // Activate lazy-loaded images in popup (swap data-srcset/data-src to srcset/src)
    function activatePopupImages($popupContent) {
        if ($popupContent.hasClass('hidden')) return; // Don't activate if hidden
        $popupContent.find('source[data-srcset]').each(function(){
            var $source = $(this);
            if (!$source.attr('srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
            }
        });
        $popupContent.find('img[data-src]').each(function(){
            var $img = $(this);
            if (!$img.attr('src')) {
                $img.attr('src', $img.attr('data-src'));
            }
        });
    }

    function setWhatsIncludedPopupState($content, shouldOpen) {
        if (!$content.length) return;

        var $productItem = $content.closest('.product-item');
        var $triggers = $productItem.find('[data-open-whats-included-popup]');

        // A product has separate image and title triggers. Close other products
        // and keep both triggers' accessibility state synchronized.
        $('.whats-included-popup-content').not($content).addClass('hidden');
        $('[data-open-whats-included-popup]').not($triggers).attr('aria-expanded', 'false');

        if (shouldOpen) {
            $content.removeClass('hidden');
            $triggers.attr('aria-expanded', 'true');
            activatePopupImages($content);
        } else {
            $content.addClass('hidden');
            $triggers.attr('aria-expanded', 'false');
        }
    }

    // Complementary cards are replaced asynchronously by
    // build-complementary-products.js. Delegate the events from document so the
    // image popup control remains reliable on slower Android devices as well.
    $(document)
        .off('click.whatsIncludedPopup', '.whats-included-popup')
        .on('click.whatsIncludedPopup', '.whats-included-popup', function(e){
            e.preventDefault();
            e.stopPropagation();
            var $content = $(this).siblings('.whats-included-popup-content');
            setWhatsIncludedPopupState($content, $content.hasClass('hidden'));
        })
        .off('click.whatsIncludedPopup', '[data-close-whats-included-popup]')
        .on('click.whatsIncludedPopup', '[data-close-whats-included-popup]', function(e){
            e.preventDefault();
            e.stopPropagation();
            setWhatsIncludedPopupState($(this).closest('.whats-included-popup-content'), false);
        })
        .off('click.whatsIncludedPopup', '[data-open-whats-included-popup]')
        .on('click.whatsIncludedPopup', '[data-open-whats-included-popup]', function(e){
            e.preventDefault();
            e.stopPropagation();
            var $content = $(this).closest('.product-item').find('.whats-included-popup-content');
            setWhatsIncludedPopupState($content, $content.hasClass('hidden'));
        })
        .off('keydown.whatsIncludedPopup', '[data-open-whats-included-popup]')
        .on('keydown.whatsIncludedPopup', '[data-open-whats-included-popup]', function(e){
            var key = e.key || e.keyCode;
            if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

}) // document ready
